import React, { useEffect, useState, useRef, useContext } from "react";
import axios from "axios";
import { Helmet } from "react-helmet";
import MobileVersion from "../components/mobileVersion/MobileVersion";
import useWindowSize from "../hooks/useWindowSize";
import classes from "./AddCustomer.module.scss";
import { JsonEditor as Editor } from "jsoneditor-react";
import { Container, Row, Col, OverlayTrigger, Tooltip, Collapse } from "react-bootstrap";
import LoadingDots from "../components/UI/LoadingDots";
import Button from "../components/UI/Button";
import { diff } from "jsondiffpatch";
import AddCustomerDetails from "../components/addCustomerElements/AddCustomerDetails";
import { OrgIdContext, CustomerRelations, ClientTypes } from "../store/orgId_context";
import { useCallback } from "react";
import AddCustomerRequest from "../components/addCustomerElements/AddCustomerRequests";
import AddCustomerResponse from "../components/addCustomerElements/AddCustomerResponse";
import OrganizationId from "../components/addCustomerElements/OrganizationId";
import JSONPretty from "../components/jsonPrettyOverride/JSONPretty";
import UserId from "../components/addCustomerElements/UserId";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useQuery } from '@tanstack/react-query'
import { DDD, E2Data, tx } from "../lib/ddd/ddd";
import ButtonLink from "../components/UI/ButtonLink";
import GenericModal from "../components/UI/GenericModal";
import UsersIds from "../components/addCustomerElements/UsersIds";
import { GenericTooltip } from "../components/integrationWizard/form/GenericTooltip";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Alert, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import ApiIcon from '@mui/icons-material/Api';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { NavLink } from "react-router-dom";
import FileUploader from "../components/profileComponents/fields/FileUploader";
import FileUploadInput from "../components/addCustomerElements/FileUploadInput";


const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const fileApiRequestAddress = process.env.REACT_APP_FILE_ENDPOINT || window.location.origin + "/File";

const ddd = new DDD(apiRequestAddress);
/*const e2Data = new E2Data("EU_CompanyAdminObject");
e2Data.format="Full";
e2Data.orderBy = "OrderInObject asc";
e2Data.take = null;*/

const basic={
  format:"Full",
  orderBy:"OrderInObject asc",
  take:null
}

/*const e2DataIL_Org = new E2Data("IL_EU_AOrg_Integration");
const e2DataIL_Service = new E2Data("IL_EU_AOrg_ServicesEndpoints");*/

const fileUploadResponse= {
    "success": true,
    "id": "0238f6c2-25f7-4419-add6-44a8f41fc03b",
    "Status": "OK",
    "Result": {
        "Id": "0238f6c2-25f7-4419-add6-44a8f41fc03b"
    }
}

const companyLogoUpload = {
    CompanyLogo : "File/0238f6c2-25f7-4419-add6-44a8f41fc03b"
}

const certificateUpload = {
    Certificate : "File/0238f6c2-25f7-4419-add6-44a8f41fc03b"
}

const apis ={
    "profile" : {
        name : "DDDI_CompanyProfile",
        nameFull : "EUeInvoices.DDDI_CompanyProfile",
        filter : "Valid=true AND Editable=true AND ForProfile=true",
        table: "EU_CompanyAdminObject",
    },
    "invoice" : {
        name : "DDDI_InvoiceVisualizationData",
        nameFull : "EUeInvoices.DDDI_InvoiceVisualizationData",
        filter : "Valid=true AND Editable=true AND ForInvoiceData=true",
        table: "EU_CompanyAdminObject",
    },
    "other" : {
        name : "DDDI_OtherSettings",
        nameFull : "EUeInvoices.DDDI_OtherSettings",
        filter : "Valid=true AND Editable=true AND ForOthSettings=true",
        table: "EU_CompanyAdminObject",
    },
    "distribution" : {
      name : "DDDI_DistributionCredentials",
      nameFull : "EUeInvoices.DDDI_DistributionCredentials",
      filter : "Valid=true",
      table: "EU_AOrg_ServicesEndpointsObject",
    },
    "mode" : {
      name : "DDDI_ChangeModeToProd",
      nameFull : "EUeInvoices.DDDI_ChangeModeToProd",
    }
}

const UpdateCustomer = () => {
    const { width } = useWindowSize();
    const [isLoading, setIsLoading] = useState(null);
    const { connectionKey, integrationDevice, setConnKeyHandler, mainOrgId, sessionInfo, customerRelation, clientType } = useContext(OrgIdContext);
    const [selectedApi, setSelectedApi] =  useState("DDDI_CompanyProfile");
    const [selectedRequestApi, setSelectedRequestApi] = useState("DDDI_CompanyProfile")
    const [editorObject, setEditorObject] = useState(null);
    const [rows, setRows] = useState();
    const [deleting, setDeleting] = useState();
    const [deleted, setDeleted] = useState();
    const [error, setError] = useState();
    const [currentCurl, setCurrentCurl] = useState(null);
    const [currentJsonrpc, setCurrentJsonrpc] = useState(null);
    const [currentFetch, setCurrentFetch] = useState(null);
    const [response, setResponse] = useState(null);
    const [isResLoading, setIsResLoading] = useState(null);
    const [e2Data] = useState(E2Data.WithConnectionKey(apiRequestAddress, integrationDevice,"EU_CompanyAdminObject").ApplyParams(basic));
    const [e2DataIL_Org] = useState(E2Data.WithConnectionKey(apiRequestAddress, integrationDevice,"IL_EU_AOrg_Integration"));
    const [e2DataIL_Service] = useState(E2Data.WithConnectionKey(apiRequestAddress, integrationDevice,"IL_EU_AOrg_ServicesEndpoints"));

    const onApiSelectChange = (e) => {
        setSelectedApi(e.target.value);
    }

    const {isPending : objDataPending, data : customerObjData, refetch} = useQuery({
        queryKey: [selectedRequestApi, e2Data.GetParamsObject()],
        queryFn: () => e2Data.GetData(),
    })
    
    const setCallExamples = (object) => {
          const curlCmd = tx(`curl -X POST https://${
            window.location.hostname
          }/api/service/EUeInvoices.${selectedRequestApi} -H "Authorization: IoT ${integrationDevice}:EUeInvoices" -H "Content-Type: application/json" -d ${JSON.stringify(
            JSON.stringify(object)
          )}`);
    
          const requestBody = tx(`RpcClient.headers['Authorization'] = 'IoT ${integrationDevice}:EUeInvoices'
          RpcClient.call("Extension.Execute", { extension: "EUeInvoices.${selectedRequestApi}", args: ${JSON.stringify(
            object
          )} }).done(res => {}).post()`);
    
          const fetchBody = `fetch(endpoint, {
            method: "POST",
            credentials: "omit",
            headers: {
              "Content-Type": "application/json",
              Authorization: "IoT ${integrationDevice}:EUeInvoices",
              "D3Pro-PreferAuthorizationOverSession": "True",
            },
            body: ${JSON.stringify(object)},
          })
            .then((response) => {})
            .catch((error) => {});`;
    
          setCurrentCurl(curlCmd);
          setCurrentJsonrpc(requestBody);
          setCurrentFetch(fetchBody);
    }


    useEffect(() => {
        if(selectedApi === "DDDI_ChangeModeToProd")
            return;
        if(objDataPending || !customerObjData)
            return;

        const data = customerObjData.result?.data;
        //const orgData =  orgData.result?.data[0];

        if(!data)
            return setError("Unable to load data");
        setRows(data);

        const emptyObj = {};
        
        data.forEach(item => {
            if(item.NameInObject){
                emptyObj[item.NameInObject] = item.Type==="boolean" ? false : null;
            }
        });

        setEditorObject(emptyObj);
        setCallExamples(emptyObj);
    }, [customerObjData,objDataPending]);

    useEffect(() => {
        setCallExamples(editorObject);
    }, [editorObject, setCallExamples]);

    useEffect(() => {
        if(!selectedApi || !getSettingsByName(selectedApi))
            return;

        if(selectedApi === "DDDI_ChangeModeToProd")
          return loadChangeMode();

        e2Data.filter = getSettingsByName(selectedApi).filter;
        e2Data.entity = getSettingsByName(selectedApi).table;

        if(selectedRequestApi === selectedApi)
          refetch();
        setSelectedRequestApi(selectedApi);
    },[selectedApi]);

    const clearTestingData = () =>{
        if(deleting) return;
        setDeleting(true);
        let finished = false;

        e2DataIL_Org.filter = "1=1";
        e2DataIL_Org.Delete().then(res => {
            if(!finished) return finished=true;
            setDeleting(false);
            setDeleted(true);
            setTimeout(() => {setDeleted(false);}, 5000);
        });

        e2DataIL_Service.filter = "1=1";
        e2DataIL_Service.Delete().then(res => {
            if(!finished) return finished=true;
            setDeleting(false);
            setDeleted(true);
            setTimeout(() => {setDeleted(false);}, 5000);
        });
    }

    const getSettingsByName = (namei) => {
        for(let [name, settings] of Object.entries(apis)){
            if(settings.name === namei)
                return settings;
        }
        return null;
    }

    const loadChangeMode = () => {
        const rows = [];
        rows.push(createBlankRow("PublicTermsAndConditionsAgreed", "PublicTermsAndConditionsAgreed", "boolean"))
        rows.push(createBlankRow("PublicSLAAgreed", "PublicSLAAgreed", "boolean"))
        setRows(rows);
        const emptyObj = {PublicTermsAndConditionsAgreed: false, PublicSLAAgreed : false};
        setEditorObject(emptyObj);
        setCallExamples(emptyObj);
    }

    const createBlankRow = (fieldName, nameInObject, type, editable=true, mandatory=false) =>{
      return {
        FieldName : fieldName,
        NameInObject: nameInObject,
        Type : type,
        Editable:editable,
        Mandatory:mandatory,
      }
    }
    const isDisabled = (fieldName) => {
        return false;
    }

    const onUploadValueChange = (fieldName, value) =>{
      updateValueByKey(fieldName, value);
    }
    const handleFieldChange = (fieldName, value) => updateValueByKey(fieldName, value);
    const updateValueByKey = (key, newValue) => {
        for (let prop in editorObject) {
          if (prop === key) {
            setEditorObject((prevEditorObject) => ({
              ...prevEditorObject,
              [key]: newValue,
            }));
            
            //renderFormField(key);
          }
        }
    };
    const getValueForFieldName = (fieldName) => {
        if(editorObject.hasOwnProperty(fieldName))
          return editorObject[fieldName];
    }

    const renderFormField = (fieldName, style) => {
        const info = getFieldInfo(fieldName);
        if(fieldName === "CompanyLogo" || fieldName === "CompanyStamp" || fieldName==="DocSignScan")
          info.Type = "file";
        switch(info?.Type){
            case "date":
                return (
                    <div key={fieldName} className="w-100" style={style}>
                      <label style={{textWrap:"nowrap"}}>{fieldName}{isMandatory(fieldName) && "*"}{getTooltip(fieldName)}{getError(fieldName)}</label>
                      <input
                        type="date"
                        defaultValue=""
                        disabled = {isDisabled(fieldName)}
                        value={getValueForFieldName(fieldName)}
                        style={getError(fieldName) !== null ? {borderColor:"red"}: {}}
                        onChange={(e) => handleFieldChange(fieldName, e.target.value)}
                      />
                    </div>
                  );
            case "datetime":
                return (
                    <div key={fieldName} className="w-100" style={style}>
                      <label style={{textWrap:"nowrap"}}>{fieldName}{isMandatory(fieldName) && "*"}{getTooltip(fieldName)}{getError(fieldName)}</label>
                      <input
                        type="datetime-local"
                        defaultValue=""
                        step={1}
                        disabled = {isDisabled(fieldName)}
                        value={getValueForFieldName(fieldName)}
                        style={getError(fieldName) !== null ? {borderColor:"red"}: {}}
                        onChange={(e) => handleFieldChange(fieldName, e.target.value)}
                      />
                    </div>
                  );
            case "decimal":
            case "integer":
                return (
                    <div key={fieldName} className="w-100" style={style}>
                      <label style={{textWrap:"nowrap"}}>{fieldName}{isMandatory(fieldName) && "*"}{getTooltip(fieldName)}{getError(fieldName)}</label>
                      <input
                        type="number"
                        defaultValue=""
                        disabled = {isDisabled(fieldName)}
                        value={getValueForFieldName(fieldName)}
                        style={getError(fieldName) !== null ? {borderColor:"red"}: {}}
                        onChange={(e) => handleFieldChange(fieldName, e.target.value.length > 0 ? parseFloat(e.target.value) : null)}
                      />
                    </div>
                  );
            case "boolean":
                return (
                    <div key={fieldName} className="w-100" style={style}>
                        <label style={{textWrap:"nowrap"}}>{fieldName}{isMandatory(fieldName) && "*"}{getTooltip(fieldName)}{getError(fieldName)}</label>
                        <select
                            onChange={(e) => handleFieldChange(fieldName, e.target.value==="true" ? true : false)}
                            value={getValueForFieldName(fieldName)}
                            disabled = {isDisabled(fieldName)}
                        >
                            <option value={true} key="true">True</option>
                            <option value={false} key="false">False</option>
                        </select>
                    </div>
                  );
            case "file":
              return (
                    <div key={fieldName} className="w-100" style={style}>
                      <label style={{textWrap:"nowrap"}}>{fieldName}{isMandatory(fieldName) && "*"}{getTooltip(fieldName)}{getError(fieldName)}</label>
                      <FileUploadInput fieldName={fieldName} onValueChange={onUploadValueChange}/>
                    </div>
                );
            default:
                return (
                    <div key={fieldName} className="w-100" style={style}>
                      <label style={{textWrap:"nowrap"}}>{fieldName}{isMandatory(fieldName) && "*"}{getTooltip(fieldName)}{getError(fieldName)}</label>
                      <input
                        type="text"
                        defaultValue=""
                        disabled = {isDisabled(fieldName)}
                        value={getValueForFieldName(fieldName)}
                        style={getError(fieldName) !== null ? {borderColor:"red"}: {}}
                        onChange={(e) => handleFieldChange(fieldName, e.target.value.length > 0 ? e.target.value : null)}
                      />
                    </div>
                  );
        }
    }

    const onSubmitCall = () => {
        //refetch();
    }

    const getTooltip = (fieldName) =>{
        const info = getFieldInfo(fieldName);
        if(!info)
          return;
        const tooltip = info.Description;
        if(!tooltip)
          return;
        return (
          <OverlayTrigger placement="left" overlay={<Tooltip>{tooltip}</Tooltip>}>
              <HelpOutlineIcon style={{marginLeft:"0.5rem", fontSize:"1rem"}}/>
          </OverlayTrigger>
        )
    }
    const getError = (fieldName) =>{return null;}
    const isMandatory = (fieldName) => {
      const info = getFieldInfo(fieldName);
      if(!info) return false;
      return info.Mandatory;
    }
    const getFieldInfo = (fieldName) =>{
        return rows.find(item => item.NameInObject === fieldName || item.FieldName === fieldName);
    }

    

    return (<>
        <Helmet>
            <title>Update customer | DDD Invoices</title>
        </Helmet>
{width > 768 && (
        <div className={`w-100 d-flex flex-column p-5 ${classes.container}`}>
            <div className={classes["blankTitle"]}>Modify</div>
            <div className={`${classes["container-panel"]}`} style={{height:"auto"}}>
                For modifying information about a company, you have the following APIs: 
                <ul>
                    <li>{tx("EUeInvoices.DDDI_CompanyProfile")}</li>
                    <li>{tx("EUeInvoices.DDDI_InvoiceVisualizationData")}</li>
                    {/* <li>EUeInvoices.DDDI_OtherSettings</li> */}
                    <li>{tx("EUeInvoices.DDDI_DistributionCredentials")}</li>
                    <li>{tx("EUeInvoices.DDDI_ChangeModeToProd")}</li>
                </ul>
                Using your <u>Integration key</u>, at the time of calling any of these APIs, a copy of your current profile/settings information is created.
                By using your integration key, you can manipulate this duplicate data as you wish. If you wish to reset your current testing data
                <Button onClick={clearTestingData} style={{marginLeft:"0.5rem"}}>click here</Button> and your current duplicate data will be deleted. As you call
                the APIs again, it a new duplicate data will be created mirroring your current profile and services settings.
                <Collapse in={deleted}>
                    <Alert severity="success" style={{marginTop:"1rem"}}>Success</Alert>
                </Collapse>
            </div>
            <div className={classes["blankTitle"]}>Get</div>
            <div className={`${classes["container-panel"]}`} style={{height:"auto"}}>
                All the APIs listed here can also return current information. This is achieved by sending an additional boolean parameter "includeGet".
                <div className={classes["code-snippet"]} style={{margin:"1rem 0rem 1rem"}}>
                  curl -X POST https://{window.location.hostname}/api/service/<span className={classes.red}>&lt;api&gt;</span> -H "Authorization: IoT <span className={classes.green}>{integrationDevice}</span>:EUeInvoices" -H "Content-Type: application/json" -d "&#123;<span className={classes.green}>includeGet : true</span>&#125;"
                </div>
                For example, your testing profile data is accasable
                <div className={classes["code-snippet"]} style={{margin:"1rem 0rem 1rem"}}>
                  curl -X POST https://{window.location.hostname}/api/service/<span className={classes.green}>{tx("EUeInvoices.DDDI_CompanyProfile")}</span> -H "Authorization: IoT <span className={classes.green}>{integrationDevice}</span>:EUeInvoices" -H "Content-Type: application/json" -d "&#123;<span className={classes.green}>includeGet : true</span>&#125;"
                </div>
                You can modify and ask API to return get also. In this example we change our CompanyAddress and get returned new profile information.
                <div className={classes["code-snippet"]} style={{margin:"1rem 0rem 1rem"}}>
                  curl -X POST https://{window.location.hostname}/api/service/<span className={classes.green}>{tx("EUeInvoices.DDDI_CompanyProfile")}</span> -H "Authorization: IoT <span className={classes.green}>{integrationDevice}</span>:EUeInvoices" -H "Content-Type: application/json" -d "&#123;<span className={classes.green}>\"CompanyAddress\" : \"New address\", \"includeGet\" : true</span>&#125;"
                </div>
            </div>
            <div className={classes["blankTitle"]}>
                <div style={{marginBottom:"1rem"}}><ApiIcon/>Select API:</div>
                <FormControl fullWidth>
                    <InputLabel id="api-select">API</InputLabel>
                    <Select
                        labelId="api-select"
                        id="demo-simple-select"
                        value={selectedApi}
                        label="Age"
                        sx={{backgroundColor:"white"}}
                        onChange={onApiSelectChange}
                    >
                        <MenuItem value={"DDDI_CompanyProfile"}>{tx("DDDI_CompanyProfile")}</MenuItem>
                        <MenuItem value={"DDDI_InvoiceVisualizationData"}>{tx("DDDI_InvoiceVisualizationData")}</MenuItem>
                        {/* <MenuItem value={"DDDI_OtherSettings"}>DDDI_OtherSettings</MenuItem> */}
                        <MenuItem value={"DDDI_DistributionCredentials"}>{tx("DDDI_DistributionCredentials")}</MenuItem>
                        <MenuItem value={"DDDI_ChangeModeToProd"}>{tx("DDDI_ChangeModeToProd")}</MenuItem>
                    </Select>
                </FormControl>
            </div>
            {(selectedApi === "DDDI_InvoiceVisualizationData" || selectedApi === "DDDI_DistributionCredentials") && <>
            <div className={classes["blankTitle"]}><AttachFileIcon/>File upload</div>
            <div className={`${classes["container-panel"]}`} style={{height:"auto", marginBottom:"1rem"}}>
              
                  Properties like {selectedApi === "DDDI_InvoiceVisualizationData" && "CompanyLogo or CompanyStamp"} {selectedApi === "DDDI_DistributionCredentials" && "Certificate"} expect a file location to be entered. But first the file must be uploaded our servers. You will do this
                  by using the following File API POST requests.
                  <div className={classes["code-snippet"]} style={{margin:"1rem 0rem 1rem"}}>
                    https://{window.location.hostname}/File
                  </div>
                  Here is an example of such a POST request in cURL
                  <div className={classes["code-snippet"]} style={{margin:"1rem 0rem 1rem"}}>
                  curl -H "Authorization: IoT {integrationDevice}:EUeInvoices" -F "data=@path/to/file" https://{window.location.hostname}/File
                  </div>
                  <div>After successfully uploading a file, the server will respond with the identification of the file uploaded (ID). Example response:</div>
                  <div className={classes["child-div-no100"]}>
                    <JSONPretty json={fileUploadResponse} style={{borderRadius:"5px"}}/>
                  </div>
                  <div>The file is now accessible via the File API on the following location:</div>
                  <div className={classes["code-snippet"]} style={{margin:"1rem 0rem 1rem"}}>
                    https://{window.location.hostname}/File/{fileUploadResponse.id}
                  </div>
                  If you wish to view the file inside your browser, you must prepend ?inline=true to your file URL
                  <Row>
                    <Col>
                      <div className={classes["code-snippet"]} style={{margin:"1rem 0rem 1rem"}}>
                      <NavLink to={`https://${window.location.hostname}/File/${fileUploadResponse.id}?inline=true`} target="_blank" rel="noopener noreferrer">
                        https://{window.location.hostname}/File/{fileUploadResponse.id}?inline=true
                      </NavLink>
                    </div>
                    </Col>
                    <Col>
                      <div style={{textAlign:"center"}}>
                        <img style={{borderRadius:"5px"}} src="https://app.dddinvoices.com/File/0238f6c2-25f7-4419-add6-44a8f41fc03b?inline=true" width="350" height="200"/>
                      </div>
                    </Col>
                  </Row>
                  
                  {selectedApi === "DDDI_InvoiceVisualizationData" &&<>
                  <div className="mt-4">Finally, the location of this file can now be added to properties like CompanyLogo or CompanyStamp in the following form:</div>
                  <div className={classes["child-div-no100"]}>
                    <JSONPretty json={companyLogoUpload}/>
                  </div>
                  </>}
                  {selectedApi === "DDDI_DistributionCredentials" &&<>
                  <div className="mt-4">Finally, the location of this file can now be added to Certificate property in the following form:</div>
                  <div className={classes["child-div-no100"]}>
                    <JSONPretty json={certificateUpload}/>
                  </div>
                  </>}
            </div>
            </>}
            <div className={`${classes["container-panel"]}`} style={{height:"auto"}}>
                {/* <div className={classes["code-snippet"]}>
                        curl -X POST https://dddinvoices.com/api/service/<span className={classes.green}>EUeInvoices.{selectedApi}</span> -H "Authorization: IoT <span className={classes.red}>&lt;connection-key&gt;</span>:EUeInvoices" -H "Content-Type: application/json" -d "&#123;<span className={classes.red}>&lt;parameters&gt;</span>&#125;"
                </div> */}
                
                <Alert severity="warning">
                    Each request must be accompanied by your customers connection key (&lt;connection-key&gt;).
                </Alert>

                <Row>
                    <Col className="col-6 pe-3">
                        <Row style={{justifyContent:"center"}}>Edit</Row>
                        <div className={classes["form-wrapper"]} style={{maxHeight:"75vh",minHeight:"25vh"}}>
                        <form>
                          {editorObject &&
                            Object.entries(editorObject).map(
                              ([fieldName, fieldConfig]) =>{
                                  if(fieldName==="CustomerObj") return;
                                  return renderFormField(fieldName)
                                }
                            )}
                        </form>
                      </div>
                      </Col>
                    <Col className="col-6 pe-3">
                    <Container className="d-flex flex-column h-100">
                        <Row style={{justifyContent:"center"}}>Upload object preview</Row>
                        <Row style={{ flex: 1 }}>
                          <Col
                            className="d-flex p-0"
                            // style={{ maxHeight: "calc(66vh - 64px)" }}
                          >
                            <div className={classes["new-invoice-response"]}>
                              <div className={classes["editor-wrapper"]}>
                                <JSONPretty data={editorObject}/>
                              </div>
                            </div>
                          </Col>
                        </Row>
                    </Container>
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Alert severity="error">In the example below, all the properties are by default set to "null" value. All the properties that are not marked by a star (*) are optional, so select only the properties
                    you wish to edit before posting such a request. <b>Setting the values to "null" will delete the information.</b></Alert>
                    <div className={classes["code-snippet"]} style={{overflowWrap:"anywhere"}}>
                            curl -X POST https://{window.location.hostname}/api/service/<span className={classes.green}>EUeInvoices.{selectedApi}</span> -H "Authorization: IoT <span className={classes.red}>&lt;connection-key&gt;</span>:EUeInvoices" -H "Content-Type: application/json" -d <span className={classes.green}>{JSON.stringify(JSON.stringify(editorObject))}</span>
                    </div>
{/*                 <Col className="col-6 pe-3">
                    <AddCustomerRequest
                    currentCurl={currentCurl}
                    currentJson={currentJsonrpc}
                    currentFetch={currentFetch}
                    />
                </Col>
                <Col className="col-6 p-0">
                    <div className="text-center">
                    <Button onClick={onSubmitCall} className="px-3">
                        Submit
                    </Button>
                    </div>
                    <AddCustomerResponse
                        response={response}
                        isLoading={isResLoading}
                    />
                </Col> */}
                </Row>
            </div>
            {objDataPending && <LoadingDots />}
        </div>
)}
{width <= 768 && <MobileVersion />}
    </>)
}
export default UpdateCustomer;